export const API_URL = "https://xzhoio91v2.execute-api.eu-west-1.amazonaws.com/Prod"
export const WS_URL = "wss://qo9fhw6e7d.execute-api.eu-west-1.amazonaws.com/prod"
